export enum CHECKOUT_CART_STATES {
  INITIAL = 'INITIAL',
  SYNCING_CART = 'SYNCING_CART',
  REFRESHING_CART = 'REFRESHING_CART',
  CART_LOADED = 'CART_LOADED',
  SYNC_ERROR = 'SYNC_ERROR',
}
